(function(){
"use strict";
var BASE = "https://tabletopterrain.com/products/";

/* ---------- hill sets & volumes ----------
   v: [monoVariantId, monoPrice, ngcVariantId, ngcPrice]  (ngc omitted = single finish) */
var SETS = {
  AS:{name:"Atlean Steppes", handle:"atlean-steppes-map-hill-sets-hextech-6mm", full:[44451316695267,385,48867792453859,462]},
  PB:{name:"Piedmont Bluffs", handle:"piedmont-bluffs-map-hill-sets-hextech-6mm", full:[44451950395619,142,49670701285603,167]},
  TP:{name:"Tetran Plains", handle:"tetran-plains-map-hill-sets-hextech-6mm", full:[44451988340963,48,49011136135395,62]},
  ZB:{name:"Zephyr Badlands", handle:"zephyr-badlands-map-hill-sets-hextech-6mm", full:[44452011081955,99,49667099394275,108]},
  SW:{name:"Sundered Wastes", handle:"sundered-wastes-map-hill-sets-hextech-6mm", full:[48478176936163,640,44452035231971,828]},
  IR:{name:"Invader's Run", handle:"hextech-invaders-run-map-hill-sets-6mm", full:[46137718833379,256,49665340932323,295]},
  MJ:{name:"Mercenary Junction", handle:"hextech-mercenary-junction-map-hill-sets-6mm", full:[46137744130275,140,49665502085347,168]},
  TV:{name:"The Veldt", handle:"hextech-the-veldt-map-hill-sets-6mm", full:[46421447540963,328,49670666846435,398]},
  CHP:{name:"Heliport / Plaza", handle:"hextech-heliport-plaza-city-map-pack", full:[47253737799907,351]},
  CEB:{name:"HPG Engineering / Business District", handle:"hextech-hpg-engineering-business-district-city-map-pack", full:[47253700968675,322]},
  CPS:{name:"Central Park / Shopping District", handle:"hextech-central-park-shopping-district-city-map-pack", full:[47253637824739,439]},
  CBF:{name:"City / Lunar BFM", handle:"hextech-city-map-pack", full:[47253354610915,787]},
  FOB:{name:"Forward Operating Base", handle:"hextech-forward-operating-base-6mm", full:[45433377652963,105,67806672355555,168]},
  RCC:{name:"Riverside Communications Center", handle:"hextech-riverside-communications-center-6mm", full:[45433366511843,95]}
};

/* semi-modular sets sold as foundation + buildings — the foundation alone is the terrain fit */
var ALT = {
  FOB_FS:["Foundation only",45433377718499,85,67806672421091,136],
  RCC_FS:["Foundation only",45433366577379,75]
};

var V = {
  AS1:["AS","Vol 1 &mdash; Grasslands #2",44451316728035,31,48867792486627,37],
  AS2:["AS","Vol 2 &mdash; Grasslands #3",44451316760803,68,48867792519395,82],
  AS3:["AS","Vol 3 &mdash; Rolling Hills #1",44451316793571,85,48867792552163,102],
  AS4:["AS","Vol 4 &mdash; Rolling Hills #3",44451316826339,68,48867792584931,82],
  AS5:["AS","Vol 5 &mdash; Rolling Hills #4",44451316859107,72,48867792617699,86],
  AS6:["AS","Vol 6 &mdash; Lakes",44451316891875,54,48867792650467,65],
  AS7:["AS","Vol 7 &mdash; Streams",44451316924643,19,48867792683235,23],
  AS8:["AS","Vol 8 &mdash; Woodlands",44451316957411,30,48867792716003,36],

  PB1:["PB","Vol 1 &mdash; Foothills #1",44451950428387,85,49670701318371,98],
  PB2:["PB","Vol 2 &mdash; Foothills #2",44451950461155,72,49670701351139,88],

  TP1:["TP","Vol 1 &mdash; Open Terrain #2",44451988373731,30,49011136168163,38],
  TP2:["TP","Vol 2 &mdash; Open Terrain #3",44451988406499,23,49011136200931,29],

  ZB1:["ZB","Vol 1 &mdash; Desert #2",44452011114723,27,49667099427043,34],
  ZB2:["ZB","Vol 2 &mdash; Desert #3",44452011147491,83,49667099459811,92],

  SWA:["SW","Airbase",48478176968931,75,44452817928419,155],
  SW1:["SW","Vol 1 &mdash; Badlands #1",48478177001699,27,44452035264739,31],
  SW2:["SW","Vol 2 &mdash; Badlands #2",48478177034467,116,44452035297507,133],
  SW3:["SW","Vol 3 &mdash; Mines #1",48478177067235,83,44452770316515,95],
  SW4:["SW","Vol 4 &mdash; Mines #2",48478177100003,27,44452770349283,31],
  SW5:["SW","Vol 5 &mdash; Oasis",48478177132771,28,44452770382051,60],
  SW6:["SW","Vol 6 &mdash; Runway",48478177165539,23,44452770414819,27],
  SW7:["SW","Vol 7 &mdash; Sand Drift #1",48478177198307,74,44452770447587,85],
  SW8:["SW","Vol 8 &mdash; Sand Drift #2",48478177231075,98,44452770480355,113],
  SW9:["SW","Vol 9 &mdash; Washout #1",48478177263843,53,44452770513123,61],
  SW10:["SW","Vol 10 &mdash; Washout #2",48478177296611,56,44452770545891,65],

  IR1:["IR","Vol 1 &mdash; Barren Lands #1",46137718866147,54,49665340965091,65],
  IR2:["IR","Vol 2 &mdash; Barren Lands #2",46137718898915,67,49665340997859,76],
  IR3:["IR","Vol 3 &mdash; Hilltops #1",46137718931683,70,49665341030627,80],
  IR4:["IR","Vol 4 &mdash; Rolling Hills #2",46137718964451,94,49665341063395,106],

  MJ1:["MJ","Vol 1 &mdash; River Valley",46137744163043,74,49665502118115,85],
  MJ2:["MJ","Vol 2 &mdash; Scattered Woods",46137744195811,18,49665502150883,24],
  MJ3:["MJ","Vol 3 &mdash; Lake Area",46137744228579,27,49665502183651,33],
  MJ4:["MJ","Vol 4 &mdash; Woodland",46137744261347,36,49665502216419,43],

  TV1:["TV","Vol 1 &mdash; Mountain Lake",46421447573731,60,49670666879203,88],
  TV2:["TV","Vol 2 &mdash; Large Lakes #1",46421447606499,36,49670666911971,42],
  TV3:["TV","Vol 3 &mdash; Large Lakes #2",46421447639267,36,49670666944739,42],
  TV4:["TV","Vol 4 &mdash; BattleTech",46421447672035,22,49670666977507,26],
  TV5:["TV","Vol 5 &mdash; CityTech",46421523267811,8,49670667010275,10],
  TV6:["TV","Vol 6 &mdash; Box Canyon",46421523300579,178,49670667043043,202],
  TV7:["TV","Vol 7 &mdash; Wide River",46427134558435,26,49670667075811,33],

  /* City Map Pack — pieces are cut per mat pairing */
  CHP_O:["CHP","HPG Offices",47253737832675,63],
  CHP_H:["CHP","HPG Heliport",47255884726499,63],
  CHP_R:["CHP","Roundabout",47253737865443,120],
  CHP_P:["CHP","Plaza",47255825481955,143],
  CEB_B:["CEB","Business District",47253701001443,73],
  CEB_O:["CEB","Observatory Hill",47253701034211,129],
  CEB_F:["CEB","Family Quarters",47255824302307,54],
  CEB_E:["CEB","HPG Engineering",47255824335075,102],
  CPS_C:["CPS","Corporate Campus",47253637857507,124],
  CPS_P:["CPS","Central Park",47253637890275,95],
  CPS_S:["CPS","Shopping District",47255822467299,124],
  CPS_D:["CPS","Park District",47255822500067,145],
  CBF_B:["CBF","Business District",47253354643683,73],
  CBF_E:["CBF","HPG Engineering",47253354676451,102],
  CBF_O:["CBF","HPG Offices",47255816667363,63],
  CBF_H:["CBF","HPG Heliport",47255816700131,63],
  CBF_F:["CBF","Family Quarters",47255816732899,54],
  CBF_P:["CBF","Central Park",47255816765667,95],
  CBF_C:["CBF","Corporate Campus",47255816798435,124],
  CBF_R:["CBF","Roundabout",47255816831203,120],

  FOB_FS:["FOB","Full Set &mdash; foundation + buildings",45433377652963,105,67806672355555,168],
  RCC_FS:["RCC","Full Set &mdash; foundation + buildings",45433366511843,95]
};

/* ---------- map sheets ----------
   name, volume key (null = no hill set), origin note */
var S = {
  "grass1"   :["Grasslands #1",      null, "Beginner Box"],
  "grass2"   :["Grasslands #2",      "AS1","A Game of Armored Combat","Headwater Crossing"],
  "grass3"   :["Grasslands #3",      "AS2","A Game of Armored Combat","Sodden Hills"],
  "des1"     :["Desert #1",          null, "Beginner Box"],
  "des2"     :["Desert #2",          "ZB1","A Game of Armored Combat","Scorched Oasis"],
  "des3"     :["Desert #3",          "ZB2","A Game of Armored Combat","Arid Canyons"],
  "foot1"    :["Foothills #1",       "PB1","Map Pack: Grasslands"],
  "foot2"    :["Foothills #2",       "PB2","Map Pack: Grasslands"],
  "ot2"      :["Open Terrain #2",    "TP1","Map Pack: Grasslands"],
  "ot3"      :["Open Terrain #3",    "TP2","Map Pack: Grasslands"],
  "rh1"      :["Rolling Hills #1",   "AS3","Map Pack: Grasslands"],
  "rh2"      :["Rolling Hills #2",   "IR4","Clan Invasion box"],
  "rh3"      :["Rolling Hills #3",   "AS4","Map Pack: Grasslands"],
  "rh4"      :["Rolling Hills #4",   "AS5","Map Pack: Grasslands"],
  "lakes"    :["Lakes",              "AS6","Map Pack: Grasslands"],
  "streams"  :["Streams",            "AS7","Map Pack: Grasslands"],
  "wood"     :["Woodland",           "AS8","Map Pack: Grasslands"],
  "fwdbase"  :["Forward Base",       "FOB_FS","Map Pack: Grasslands"],
  "rivercc"  :["River CommCenter",   "RCC_FS","Map Pack: Grasslands"],
  "barren1"  :["Barren Lands #1",    "IR1","Clan Invasion box"],
  "barren2"  :["Barren Lands #2",    "IR2","Clan Invasion box"],
  "hilltops1":["Hilltops #1",        "IR3","Clan Invasion box"],
  "rivval"   :["River Valley",       "MJ1","Mercenaries box"],
  "scatwood" :["Scattered Woods",    "MJ2","Mercenaries box"],
  "lakearea" :["Lake Area",          "MJ3","Mercenaries box"],
  "woodmerc" :["Woodland",           "MJ4","Mercenaries box"],
  "aero1"    :["AeroBase #1",        "SWA","Map Pack: Deserts"],
  "aero2"    :["AeroBase #2",        "SWA","Map Pack: Deserts"],
  "bad1"     :["Badlands #1",        "SW1","Map Pack: Deserts"],
  "bad2"     :["Badlands #2",        "SW2","Map Pack: Deserts"],
  "mines1"   :["Mines #1",           "SW3","Map Pack: Deserts"],
  "mines2"   :["Mines #2",           "SW4","Map Pack: Deserts"],
  "oasis"    :["Oasis",              "SW5","Map Pack: Deserts"],
  "runway"   :["Desert Runway",      "SW6","Map Pack: Deserts"],
  "sand1"    :["Sand Drift #1",      "SW7","Map Pack: Deserts"],
  "sand2"    :["Sand Drift #2",      "SW8","Map Pack: Deserts"],
  "wash1"    :["Washout #1",         "SW9","Map Pack: Deserts"],
  "wash2"    :["Washout #2",         "SW10","Map Pack: Deserts"],
  "mtlake"   :["Mountain Lake",      "TV1","Map Pack: Savannah"],
  "ll1"      :["Large Lakes #1",     "TV2","Map Pack: Savannah"],
  "ll2"      :["Large Lakes #2",     "TV3","Map Pack: Savannah"],
  "btech"    :["BattleTech",         "TV4","Map Pack: Savannah"],
  "ctech"    :["CityTech",           "TV5","Map Pack: Savannah"],
  "boxcan"   :["Box Canyon",         "TV6","Map Pack: Savannah"],
  "widriv"   :["Wide River",         "TV7","Map Pack: Savannah"],
  "sink1"    :["Sinkhole #1",        null, "Map Pack: Savannah"],
  "sink2"    :["Sinkhole #2",        null, "Map Pack: Savannah"],
  "cityruin" :["City Ruins",         null, "Map Pack: Savannah"],
  "rdelta1"  :["River Delta / Drainage Basin #1", null,"Map Pack: Savannah"],
  "rdelta2"  :["River Delta / Drainage Basin #2", null,"Map Pack: Savannah"],
  /* City Map Pack — hill/building sets are cut per BattleMat pairing */
  "c_cpark"  :["City: Central Park",       "CPS_P","Map Pack: City"],
  "c_bdist"  :["City: Business District",  "CEB_B","Map Pack: City"],
  "c_ccamp"  :["City: Corporate Campus",   "CPS_C","Map Pack: City"],
  "c_round"  :["City: Roundabout",         "CHP_R","Map Pack: City"],
  "c_fquart" :["City: Family Quarters",    "CEB_F","Map Pack: City"],
  "c_obs"    :["City: Observatory Hill",   "CEB_O","Map Pack: City"],
  "c_hpge"   :["City: HPG Engineering",    "CEB_E","Map Pack: City"],
  "c_pdist"  :["City: Park District",      "CPS_D","Map Pack: City"],
  "c_heli"   :["City: HPG Heliport",       "CHP_H","Map Pack: City"],
  "c_shop"   :["City: Shopping District",  "CPS_S","Map Pack: City"],
  "c_hpgo"   :["City: HPG Offices",        "CHP_O","Map Pack: City"],
  "c_plaza"  :["City: Plaza",              "CHP_P","Map Pack: City"]
};

/* ---------- boxed sets & map packs ---------- */
var PRODUCTS = [
  {id:"agoac", group:"Boxed sets", name:"BattleTech: A Game of Armored Combat", code:"CAT35010",
   meta:"2 double-sided 18″ × 22″ paper mapsheets",
   sides:[{label:"Sheet 1", f:["grass2","des2"]},{label:"Sheet 2", f:["grass3","des3"]}],
   note:"Fully covered: Atlean Steppes Vols 1&ndash;2 for the grasslands faces, Zephyr Badlands Vols 1&ndash;2 for the deserts. These same four maps return in the 2026 Core Box under new names &mdash; same layouts, same hills."},

  {id:"corebox2026", group:"Boxed sets", name:"BattleTech: Core Box (2026)", code:"CAT37002",
   meta:"2 double-sided mapsheets - 4 faces", useAlias:true,
   sides:[{label:"The four map faces", f:["grass2","grass3","des2","des3"]}],
   note:"The 2026 Core Box reprints the four A Game of Armored Combat maps with revised art and new names. The hex layouts and elevations are unchanged, so the existing hill sets fit exactly &mdash; Atlean Steppes Vols 1&ndash;2 for the two grassland maps, Zephyr Badlands Vols 1&ndash;2 for the two desert maps."},

  {id:"beginner", group:"Boxed sets", name:"BattleTech: Beginner Box", code:"CAT35000",
   meta:"1 double-sided 18″ × 22″ paper mapsheet",
   sides:[{label:"Sheet 1", f:["grass1","des1"]}],
   note:"No hill sets exist for Grasslands #1 or Desert #1 yet. If you're stepping up from the Beginner Box, A Game of Armored Combat's four faces are all covered."},

  {id:"claninv", group:"Boxed sets", name:"BattleTech: Clan Invasion", code:"CAT35030",
   meta:"2 double-sided 18″ × 22″ paper mapsheets",
   sides:[{label:"Sheet 1", f:["hilltops1","barren1"]},{label:"Sheet 2", f:["rh2","barren2"]}],
   note:"All four faces are covered by Invader's Run &mdash; the Full Set Bundle is the whole box in one order."},

  {id:"mercs", group:"Boxed sets", name:"BattleTech: Mercenaries", code:"CAT35040",
   meta:"2 double-sided 18″ × 22″ paper mapsheets",
   sides:[{label:"Sheet 1", f:["scatwood","rivval"]},{label:"Sheet 2", f:["woodmerc","lakearea"]}],
   note:"All four faces are covered by Mercenary Junction. Note this box's Woodland is its own map &mdash; it is not the Map Pack: Grasslands Woodland, which uses Atlean Steppes Vol 8."},

  {id:"mp-grass", group:"Map packs", name:"Map Pack: Grasslands", code:"CAT35154",
   meta:"6 double-sided 18″ × 22″ paper maps — 12 faces",
   sides:[
     {label:"Sheet 1", f:["foot1","rh1"]},
     {label:"Sheet 2", f:["foot2","lakes"]},
     {label:"Sheet 3", f:["ot2","wood"]},
     {label:"Sheet 4", f:["ot3","fwdbase"]},
     {label:"Sheet 5", f:["rh3","streams"]},
     {label:"Sheet 6", f:["rh4","rivercc"]}],
   note:"All twelve faces are covered, across five products. The two facility maps use the stand-alone base sets, which ship as a foundation plus hexed buildings &mdash; the foundation alone is what matches the printed map, so it's listed separately below."},

  {id:"mp-des", group:"Map packs", name:"Map Pack: Deserts", code:"CAT35155",
   meta:"6 double-sided 18″ × 22″ paper maps — 12 faces",
   sides:[
     {label:"Sheet 1", f:["aero1","bad1"]},
     {label:"Sheet 2", f:["bad2","aero2"]},
     {label:"Sheet 3", f:["mines1","runway"]},
     {label:"Sheet 4", f:["oasis","sand2"]},
     {label:"Sheet 5", f:["wash2","mines2"]},
     {label:"Sheet 6", f:["sand1","wash1"]}],
   note:"Sundered Wastes covers all twelve faces. One Airbase set serves both AeroBase #1 and AeroBase #2."},

  {id:"mp-sav", group:"Map packs", name:"Map Pack: Savannah", code:"CAT35156",
   meta:"6 double-sided 17″ × 22″ paper maps — 12 faces",
   sides:[
     {label:"Sheet 1", f:["ll1","btech"]},
     {label:"Sheet 2", f:["ll2","boxcan"]},
     {label:"Sheet 3", f:["sink1","cityruin"]},
     {label:"Sheet 4", f:["sink2","ctech"]},
     {label:"Sheet 5", f:["rdelta1","mtlake"]},
     {label:"Sheet 6", f:["rdelta2","widriv"]}],
   note:"The Veldt covers seven of the twelve faces. The Sinkholes, City Ruins and River Delta faces have no hill set yet."},

  {id:"mp-city", group:"Map packs", name:"Map Pack: City", code:"CAT35157",
   meta:"6 double-sided 17″ × 22″ paper maps — 12 faces",
   sides:[
     {label:"Sheet 1", f:["c_cpark","c_bdist"]},
     {label:"Sheet 2", f:["c_ccamp","c_round"]},
     {label:"Sheet 3", f:["c_fquart","c_obs"]},
     {label:"Sheet 4", f:["c_hpge","c_pdist"]},
     {label:"Sheet 5", f:["c_heli","c_shop"]},
     {label:"Sheet 6", f:["c_hpgo","c_plaza"]}],
   note:"City pieces are cut per BattleMat pairing rather than as one numbered range, so the twelve faces span three products. If you own the paper pack, the parts below still line up face-for-face. Buying by mat instead? Use the BattleMats tab."},

  {id:"mp-alien", group:"Map packs", name:"Map Pack: Alien Worlds", code:"CAT35158",
   meta:"2 double-sided 34″ × 22″ paper maps — 4 faces",
   sides:[{label:"Faces", f:[]}],
   raw:["Fungal Crevasse","Caustic Valley","Lunar Base","Crystalline Canyon"],
   note:"No hill sets for the Alien Worlds faces. If you own the neoprene versions, note that their reverse sides are Map Pack: Deserts maps &mdash; those are covered by Sundered Wastes. Check the BattleMats tab."},

  {id:"mp-tuk", group:"Map packs", name:"Map Pack: Battle of Tukayyid", code:"CAT35153",
   meta:"4 double-sided 34″ × 22″ paper maps — 8 faces",
   sides:[{label:"Faces", f:[]}],
   raw:["Racice River Delta","Deployment Zone","Holth Forest","Lake Losiije","Robyn's Crossing","Devil's Bath","Pozoristu Mountains","Kozice Valley"],
   note:"No hill sets for the Tukayyid maps."},

  {id:"mp-fire", group:"Map packs", name:"Map Pack: Volcanic &amp; Glacier", code:"CAT35160/61",
   meta:"12 faces each",
   sides:[{label:"Faces", f:[]}],
   raw:["All Volcanic faces","All Glacier faces"],
   note:"No hill sets for the Fire and Ice ranges yet."}
];

/* ---------- neoprene BattleMats ---------- */
var MATS = [
  {id:"rgk", group:"Starter", name:"BattleTech: Retail Grinder Kit mat", code:"CAT35RGK",
   meta:"Reproduces the A Game of Armored Combat maps",
   sides:[{label:"Side A", f:["grass3"]},{label:"Side B", f:["des2"]}]},

  {id:"800a", group:"Grassland Collection", name:"Grasslands A / Desert", code:"CAT35800A", meta:"34″ × 22″ — two mapsheets per side",
   sides:[{label:"Grasslands side", f:["foot2","rh4"]},{label:"Desert side", f:[]}],
   raw:["New desert artwork — no paper original"],
   note:"Only the grasslands side reproduces printed map sheets. The reverse is new biome art with no corresponding hill set."},
  {id:"800b", group:"Grassland Collection", name:"Grasslands B / Lunar", code:"CAT35800B", meta:"34″ × 22″",
   sides:[{label:"Grasslands side", f:["fwdbase","ot2"]},{label:"Lunar side", f:[]}],
   raw:["New lunar artwork — no paper original"]},
  {id:"800c", group:"Grassland Collection", name:"Grasslands C / Alpine", code:"CAT35800C", meta:"34″ × 22″",
   sides:[{label:"Grasslands side", f:["rh3","foot1"]},{label:"Alpine side", f:[]}],
   raw:["New alpine artwork — no paper original"]},
  {id:"800d", group:"Grassland Collection", name:"Grasslands D / Savanna", code:"CAT35800D", meta:"34″ × 22″",
   sides:[{label:"Grasslands side", f:["ot3","streams"]},{label:"Savanna side", f:[]}],
   raw:["New savanna artwork — no paper original"]},
  {id:"800e", group:"Grassland Collection", name:"Grasslands E / Tundra", code:"CAT35800E", meta:"34″ × 22″",
   sides:[{label:"Grasslands side", f:["lakes","rivercc"]},{label:"Tundra side", f:[]}],
   raw:["New tundra artwork — no paper original"]},

  {id:"800p", group:"Alien Worlds Collection", name:"Lunar Base / Sand Drift", code:"CAT35800P", meta:"34″ × 22″",
   sides:[{label:"Lunar Base side", f:[]},{label:"Sand Drift side", f:["sand1","sand2"]}],
   raw:["Lunar Base — no hill set"]},
  {id:"800q", group:"Alien Worlds Collection", name:"Fungal Crevasse / Washout", code:"CAT35800Q", meta:"34″ × 22″",
   sides:[{label:"Fungal Crevasse side", f:[]},{label:"Washout side", f:["wash1","wash2"]}],
   raw:["Fungal Crevasse — no hill set"]},
  {id:"800r", group:"Alien Worlds Collection", name:"Caustic Valley / Mine", code:"CAT35800R", meta:"34″ × 22″",
   sides:[{label:"Caustic Valley side", f:[]},{label:"Mine side", f:["mines1","mines2"]}],
   raw:["Caustic Valley — no hill set"]},
  {id:"800s", group:"Alien Worlds Collection", name:"Crystalline Canyon / Badlands", code:"CAT35800S", meta:"34″ × 22″",
   sides:[{label:"Crystalline Canyon side", f:[]},{label:"Badlands side", f:["bad1","bad2"]}],
   raw:["Crystalline Canyon — no hill set"]},

  {id:"800v", group:"Alpha Strike hexless", name:"Aerobase #1", code:"CAT35800V", meta:"34″ × 22″ — hexless",
   sides:[{label:"Desert side", f:["aero1","aero2"]},{label:"Grasslands side", f:["wood","rh1"]}],
   note:"Its desert side is AeroBase #1 and #2, and the single Airbase pack covers both &mdash; you only need one. Hexless mats take the same hills either way: the pieces are cut to the printed contours, not to the hex grid."},
  {id:"800w", group:"Alpha Strike hexless", name:"Aerobase #2", code:"CAT35800W", meta:"34″ × 22″ — hexless",
   sides:[{label:"Desert side", f:["runway","oasis"]},{label:"Grasslands side", f:["hilltops1","rh2"]}],
   note:"The grasslands side of this mat reproduces the Hilltops #1 and Rolling Hills #2 sheets, which ship in the Clan Invasion box &mdash; so those two come from Invader's Run rather than Atlean Steppes."},

  {id:"800mm", group:"Battalion Forces Mats (72″ × 48″)", name:"BFM Grasslands / Deserts", code:"CAT35800MM",
   meta:"72″ × 48″ — eight mapsheets per side",
   sides:[
     {label:"Deserts side", f:["bad2","wash1","aero1","aero2","wash2","mines2","runway","oasis"]},
     {label:"Grasslands side", f:["rh4","rh1","streams","lakes","rh3","ot2","rivercc","ot3"]}],
   note:"The big one. Eight map faces per side, so this needs the most volumes of any mat &mdash; the bundle maths below is worth reading."},

  {id:"801a", group:"Savannah Collection", name:"Large Lakes / Box Canyon", code:"CAT35801A", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["ll1","ll2"]},{label:"Side B", f:["boxcan","btech"]}]},
  {id:"801b", group:"Savannah Collection", name:"River Delta / City Ruins", code:"CAT35801B", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["rdelta1","rdelta2"]},{label:"Side B", f:["cityruin","ctech"]}]},
  {id:"801c", group:"Savannah Collection", name:"Sinkholes / Mountain Lake", code:"CAT35801C", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["sink1","sink2"]},{label:"Side B", f:["mtlake","widriv"]}]},

  {id:"801x", group:"City Collection", name:"City &mdash; HPG Heliport / Plaza", code:"CAT35801X", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["c_heli","c_hpgo"]},{label:"Side B", f:["c_plaza","c_round"]}],
   note:"Every piece for this mat lives in one product &mdash; the Heliport / Plaza set. Buy the Full Set for the whole mat."},
  {id:"801y", group:"City Collection", name:"City &mdash; HPG Engineering / Business District", code:"CAT35801Y", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["c_hpge","c_obs"]},{label:"Side B", f:["c_bdist","c_fquart"]}],
   note:"Every piece for this mat lives in one product &mdash; the HPG Engineering / Business District set."},
  {id:"801z", group:"City Collection", name:"City &mdash; Central Park / Shopping District", code:"CAT35801Z", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["c_cpark","c_ccamp"]},{label:"Side B", f:["c_shop","c_pdist"]}],
   note:"Every piece for this mat lives in one product &mdash; the Central Park / Shopping District set."},

  {id:"801mm", group:"Battalion Forces Mats (72″ × 48″)", name:"BFM City / Lunar", code:"CAT35801MM",
   meta:"72″ × 48″ — eight city maps on the city side",
   sides:[{label:"City side", f:[]},{label:"Lunar side", f:[]}],
   custom:"CBF",
   note:"The BFM city pieces are their own product, sized and arranged for the 72″ × 48″ mat &mdash; don't substitute the 34″ × 22″ city sets. Two extra centrepieces, the Central Facility Raised Structure and the Interstellar Communications Facility, are exclusive to this mat. The lunar side has no hill set."},

  {id:"802mm", group:"Battalion Forces Mats (72″ × 48″)", name:"BFM Volcanic / Glacier", code:"CAT35802MM",
   meta:"72″ × 48″", sides:[{label:"Both sides", f:[]}],
   raw:["Volcanic and Glacier faces — no hill sets yet"]},

  {id:"tuk", group:"No hill sets yet", name:"Battle of Tukayyid mats", code:"CAT35800F–I", meta:"Racice River Delta, Holth Forest, Robyn's Crossing, Pozoristu Mountains and their reverses",
   sides:[{label:"All faces", f:[]}], raw:["No hill sets"]},
  {id:"misc", group:"No hill sets yet", name:"Strana Mechty, Aerospace, FieldTech, Legendary Battles, Fire and Ice", code:"CAT35800J–L, 35801D–Q", meta:"Hexless FieldTech mats, Thunder Rift / Misery, Twycross, the Fire and Ice range",
   sides:[{label:"All faces", f:[]}], raw:["No hill sets"]}
];

/* ---------- live pricing ----------
   Inside Shopify the section emits window.TT_LIVE with every variant's
   real price, stock and photo in the buyer's market and currency.
   Anywhere else the USD figures in the tables above are used. */
var LIVE = (window.TT_LIVE && window.TT_LIVE.variants) || null;
var CURRENCY = (window.TT_LIVE && window.TT_LIVE.currency) || "USD";
var fmt;
try{ fmt = new Intl.NumberFormat(undefined, {style:"currency", currency:CURRENCY}); }catch(e){ fmt = null; }
function money(n){ return fmt ? fmt.format(n) : "$" + n.toFixed(2); }
function px(id, fallback){ return (LIVE && LIVE[id]) ? LIVE[id][0] / 100 : fallback; }
function inStock(id){ if(!LIVE) return true; var r = LIVE[id]; return r ? !!r[1] : true; }
function img(id){ return (LIVE && LIVE[id] && LIVE[id][2]) || ""; }

var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || null;
var ON_SHOPIFY = !!ROOT || !!LIVE;
function url(handle, variant){ return (ROOT ? ROOT + "products/" + handle : BASE + handle) + "?variant=" + variant; }
function route(p){ return (ROOT || "/") + p; }

/* the NextGen Color mark used on the product pages */
var RGB = '<svg class="rgb" viewBox="0 0 40 36" width="22" height="20" aria-hidden="true" focusable="false"><circle cx="20" cy="12" r="10" fill="#ff2d2d"/><circle cx="12.5" cy="24" r="10" fill="#22c55e"/><circle cx="27.5" cy="24" r="10" fill="#2f6bff"/></svg>';
var GRAY = '<svg class="rgb" viewBox="0 0 40 36" width="22" height="20" aria-hidden="true" focusable="false"><circle cx="20" cy="18" r="14" fill="#9B9B9B"/></svg>';

/* ---------- state ---------- */
var color = "ngc";
var current = {kind:"product", id:"corebox2026"};   /* never empty: open on the most common box */
var inCart = {};             /* variantId -> qty, read from /cart.js */
var howOpen = false;
var busy = {};               /* variantId -> "adding" | "err" while a cart call is out */
var expanded = {};           /* setKey -> true when a Full Set card is opened into its volumes */

var hfEl    = document.querySelector(".hf");
var pickEl  = document.querySelector(".hf .pick");
var boxesEl = document.getElementById("hf-boxes");
var packsEl = document.getElementById("hf-packs");
var matsEl  = document.getElementById("hf-mats");
var sheetsEl = document.getElementById("hf-sheets");
var ansEl   = document.getElementById("hf-ans");
var jumpEl  = document.getElementById("hf-jump");
var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
var stacked = window.matchMedia("(max-width: 959px)");

/* ---------- helpers ---------- */
function vol(key){
  var v = V[key]; if(!v) return null;
  var hasNgc = v.length > 4, useNgc = color === "ngc" && hasNgc;
  var id = useNgc ? v[4] : v[2];
  return {key:key, setKey:v[0], set:SETS[v[0]], label:v[1], variant:id, img:img(id) || img(v[4] || v[2]),
          price:px(id, useNgc ? v[5] : v[3]), stock:inStock(id), grayOnly:!hasNgc};
}
function fullOf(sk){
  var f = SETS[sk].full, hasNgc = f.length > 2, useNgc = color === "ngc" && hasNgc;
  var id = useNgc ? f[2] : f[0];
  return {variant:id, img:img(id) || img(f[2] || f[0]), price:px(id, useNgc ? f[3] : f[1]), stock:inStock(id), grayOnly:!hasNgc};
}
function volsOf(sk){ return Object.keys(V).filter(function(vk){ return V[vk][0] === sk && !/_FS$/.test(vk); }); }
function facesOf(item){
  var k = [];
  (item.sides || []).forEach(function(s){ k = k.concat(s.f); });
  return k;
}
function coverage(item){
  var f = facesOf(item);
  var covered = f.filter(function(k){ return !!S[k][1]; }).length;
  return {covered:covered, total:f.length + (item.raw ? item.raw.length : 0)};
}
function hasHills(item){ return !!item.custom || coverage(item).covered > 0; }
function itemFor(sel){
  if(!sel) return null;
  if(sel.kind === "product") return PRODUCTS.filter(function(p){ return p.id === sel.id; })[0];
  if(sel.kind === "mat") return MATS.filter(function(m){ return m.id === sel.id; })[0];
  var s = S[sel.id];
  return {name:s[0] + (s[3] ? " / " + s[3] : ""), sides:[{label:"", f:[sel.id]}], single:true};
}
function sheetName(k, useAlias){ var s = S[k]; return (useAlias && s[3]) ? s[3] : s[0]; }

/* What to buy. Each needed volume once; wherever a set's Full Set costs the
   same or less than the separate volumes, the Full Set replaces them. */
function plan(item){
  var used = {};
  facesOf(item).forEach(function(k){ if(S[k][1]) used[S[k][1]] = true; });
  var need = Object.keys(V).filter(function(vk){ return used[vk] || (item.custom && V[vk][0] === item.custom); });
  var bySet = {}, order = [];
  need.forEach(function(vk){
    var sk = V[vk][0];
    if(!bySet[sk]){ bySet[sk] = []; order.push(sk); }
    bySet[sk].push(vk);
  });
  var lines = [];
  order.forEach(function(sk){
    var vols = bySet[sk].map(vol);
    var sum = vols.reduce(function(a, v){ return a + v.price; }, 0);
    var f = fullOf(sk);
    var range = volsOf(sk).length;
    if(vols.length > 1 && f.price <= sum){
      lines.push({setKey:sk, set:SETS[sk], label:"Full Set &mdash; " + (range === 2 ? "both volumes" : "all " + range + " volumes"), variant:f.variant,
                  img:f.img, price:f.price, stock:f.stock, grayOnly:f.grayOnly,
                  saves: sum - f.price > 0.5 ? sum - f.price : 0, bundle:true});
    } else {
      vols.forEach(function(v){ lines.push(v); });
    }
  });
  return lines;
}

/* ---------- step 1: the choices ---------- */
function shortName(p){ return p.name.replace(/^BattleTech:\s*/,"").replace(/^Map Pack:\s*/,""); }
function thumb(src){ return src ? src.replace(/width=\d+/, "width=200") : ""; }
function fitMeta(item){
  var c = coverage(item);
  if(item.custom) return '<span class="ok">fits the city side</span>';
  return c.covered === c.total ? (c.total + ' maps &middot; <span class="ok">all fit</span>') : (c.total + ' maps &middot; ' + c.covered + ' fit');
}
function optHtml(kind, id, name, meta, src){
  return '<button type="button" class="opt" data-kind="'+kind+'" data-id="'+id+'" aria-pressed="false">'
       + '<span class="opt__img">'+(src ? '<img src="'+thumb(src)+'" alt="" loading="lazy" width="200" height="150">' : '')+'</span>'
       + '<span class="opt__txt"><span class="opt__name">'+name+'</span>'
       + '<span class="opt__meta">'+meta+'</span></span></button>';
}
function itemThumb(item){ var l = plan(item)[0]; return l ? l.img : ""; }
function buildChoices(){
  var boxOrder = ["corebox2026","agoac","claninv","mercs"];
  boxesEl.innerHTML = boxOrder.map(function(id){
    return PRODUCTS.filter(function(p){ return p.id === id; })[0];
  }).filter(function(p){ return p && hasHills(p); }).map(function(p){
    return optHtml("product", p.id, shortName(p), fitMeta(p), itemThumb(p));
  }).join("");

  packsEl.innerHTML = PRODUCTS.filter(function(p){ return p.group === "Map packs" && hasHills(p); }).map(function(p){
    return optHtml("product", p.id, shortName(p), fitMeta(p), itemThumb(p));
  }).join("");

  /* mats, grouped, only the ones that take hills */
  var html = "", g = null;
  MATS.filter(hasHills).forEach(function(m){
    if(m.group !== g){ g = m.group; html += '<div class="opts__grp">'+g+'</div>'; }
    html += optHtml("mat", m.id, m.name, fitMeta(m), itemThumb(m));
  });
  matsEl.innerHTML = html;

  /* single sheets, grouped by where they come from */
  var rows = Object.keys(S).filter(function(k){ return !!S[k][1]; }).map(function(k){
    return {k:k, name:S[k][0] + (S[k][3] ? " / " + S[k][3] : ""), from:S[k][2]};
  }).sort(function(a, b){ return a.from.localeCompare(b.from) || a.name.localeCompare(b.name); });
  html = ""; g = null;
  rows.forEach(function(r){
    if(r.from !== g){ g = r.from; html += '<div class="opts__grp">'+g+'</div>'; }
    var v = vol(S[r.k][1]);
    html += optHtml("sheet", r.k, r.name, v.set.name + ' &middot; ' + v.label.replace(/ &mdash;.*/, ""), v.img);
  });
  sheetsEl.innerHTML = html;
}
function secOf(sel){
  if(!sel) return null;
  if(sel.kind === "product"){ var p = itemFor(sel); return p && p.group === "Map packs" ? "product-pack" : "product-box"; }
  return sel.kind;
}
function markChoice(){
  var name = null;
  document.querySelectorAll(".hf .opt").forEach(function(c){
    var on = !!current && current.kind === c.getAttribute("data-kind") && current.id === c.getAttribute("data-id");
    c.setAttribute("aria-pressed", String(on));
    if(on) name = c.querySelector(".opt__name").innerHTML;
  });
  /* a closed section still says what's picked inside it */
  var sec = secOf(current);
  document.querySelectorAll(".hf .sec").forEach(function(d){
    var mine = d.getAttribute("data-sec") === sec;
    d.classList.toggle("has-pick", mine);
    d.querySelector(".sec__pick").innerHTML = mine && name ? name : "";
  });
}

/* ---------- step 2: the answer ---------- */
function buyBtn(l){
  var id = l.variant;
  if(!l.stock) return '<button type="button" class="pc__add" disabled>Sold out</button>';
  if(busy[id] === "adding") return '<button type="button" class="pc__add" disabled>Adding&hellip;</button>';
  if(busy[id] === "err") return '<button type="button" class="pc__add is-err" data-ids="'+id+'">Couldn\'t add &mdash; retry</button>';
  if(inCart[id]) return '<button type="button" class="pc__add is-done" data-ids="'+id+'">&#10003; In cart'+(inCart[id] > 1 ? ' &times; '+inCart[id] : '')+' &middot; add another</button>';
  return '<button type="button" class="pc__add" data-ids="'+id+'">Add to cart</button>';
}
function cardHtml(l, extra){
  var href = url(l.set.handle, l.variant);
  var tags = "";
  if(l.saves) tags += '<span class="tag tag--good">Saves '+money(l.saves)+'</span>';
  if(l.grayOnly && color === "ngc") tags += '<span class="tag">Gray only</span>';
  return '<article class="pc'+(inCart[l.variant] ? ' is-in' : '')+(l.bundle && expanded[l.setKey] ? ' is-open' : '')+'">'
       + '<a class="pc__img" href="'+href+'" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true">'
       +   (l.img ? '<img src="'+l.img+'" alt="" loading="lazy" width="600" height="450">' : '<span class="pc__ph"></span>')
       +   (tags ? '<span class="pc__tags">'+tags+'</span>' : '')
       + '</a>'
       + '<div class="pc__body">'
       +   '<span class="pc__set">'+l.set.name+'</span>'
       +   '<a class="pc__name" href="'+href+'" target="_blank" rel="noopener">'+l.label+'</a>'
       +   '<div class="pc__row"><span class="pc__price">'+(l.stock ? money(l.price) : 'Sold out')+'</span>'
       +   '<a class="pc__view" href="'+href+'" target="_blank" rel="noopener">Details</a></div>'
       +   buyBtn(l)
       +   (extra || '')
       + '</div></article>';
}
function renderAnswer(){
  var item = itemFor(current);
  if(!item){ ansEl.innerHTML = ""; return; }

  var lines = plan(item);
  var c = coverage(item);
  var fitText, fitAll = false;
  if(item.custom){ fitText = "Fits every map on the city side."; fitAll = true; }
  else if(item.single){ fitText = "One volume covers this map."; fitAll = true; }
  else if(c.covered === c.total){ fitText = "Fits all " + c.total + " maps."; fitAll = true; }
  else { fitText = "Fits " + c.covered + " of the " + c.total + " maps. The rest don't have hill sets yet."; }

  var total = 0, ids = [], missing = [];
  var cards = lines.map(function(l){
    total += l.price;
    if(l.stock){ ids.push(l.variant); if(!inCart[l.variant]) missing.push(l.variant); }
    if(!l.bundle) return cardHtml(l);
    /* a Full Set opens into its volumes, each with its own photo, price and button */
    var n = volsOf(l.setKey).length, open = !!expanded[l.setKey];
    var toggle = '<button type="button" class="pc__more" data-expand="'+l.setKey+'" aria-expanded="'+open+'">'
               + (open ? 'Hide the volumes' : 'Or buy single volumes ('+n+')') + '</button>';
    var html = cardHtml(l, toggle);
    if(open){
      html += '<div class="pcs__sub" role="group" aria-label="'+l.set.name+' volumes">'
            + '<p class="pcs__subhd"><b>'+l.set.name+'</b> &mdash; each volume on its own</p>'
            + '<div class="pcs__subgrid">' + volsOf(l.setKey).map(function(vk){ return cardHtml(vol(vk)); }).join("") + '</div></div>';
    }
    return html;
  }).join("");

  var btn;
  if(!ids.length){
    btn = '<button type="button" class="addall" disabled>Sold out</button>';
  } else if(!missing.length){
    btn = '<a class="addall is-done" href="'+route("cart")+'">All in your cart &middot; View cart &rarr;</a>';
  } else {
    btn = '<button type="button" class="addall" data-ids="'+missing.join(",")+'">'
        + (missing.length === ids.length ? (ids.length === 1 ? "Add to cart" : "Add all " + ids.length + " to cart") : "Add the other " + missing.length + " to cart")
        + '</button>';
  }
  var anyIn = ids.some(function(id){ return inCart[id]; });

  var html = ''
    + '<div class="ans__top">'
    +   '<div class="ans__head">'
    +     '<h2 class="ans__title">'+item.name+'</h2>'
    +     '<p class="ans__fit'+(fitAll ? ' is-all' : '')+'">'+(fitAll ? '&#10003; ' : '')+fitText+'</p>'
    +   '</div>'
    +   '<button type="button" class="ans__change" data-change>Change</button>'
    + '</div>'

    + '<div class="finish" role="group" aria-label="Finish">'
    +   '<button type="button" data-color="ngc" aria-pressed="'+(color === "ngc")+'">'+RGB
    +     '<span><b>NextGen Color</b><small>Fully colored, ready to play</small></span></button>'
    +   '<button type="button" data-color="mono" aria-pressed="'+(color === "mono")+'">'+GRAY
    +     '<span><b>Monocolor</b><small>Gray, ready to paint</small></span></button>'
    + '</div>'

    + '<div class="pcs">'+cards+'</div>'

    /* one card already has its own button; the bar is for two or more */
    + (lines.length < 2 ? '' : '<div class="buybar">'
    +   '<div class="tot"><span>'+lines.length+' items</span>'+money(total)+'</div>'
    +   '<div class="buybar__act">'+(anyIn && missing.length ? '<a class="cartlink" href="'+route("cart")+'">View cart</a>' : '')+btn+'</div>'
    + '</div>')

    + howHtml(item);

  ansEl.innerHTML = html;
  fitSticky();
}

/* the per-map breakdown, for the curious */
function howHtml(item){
  var rows = "";
  var multi = (item.sides || []).filter(function(s){ return s.f.length; }).length > 1;
  (item.sides || []).forEach(function(s){
    if(!s.f.length) return;
    if(multi && s.label) rows += '<tr class="side"><td colspan="2">'+s.label+'</td></tr>';
    s.f.forEach(function(k){
      var vk = S[k][1], v = vk ? vol(vk) : null;
      var other = item.useAlias ? (S[k][3] ? "Same map as " + S[k][0] : "") : (S[k][3] ? "2026 Core Box: " + S[k][3] : "");
      var a = vk && ALT[vk], aNgc = a && color === "ngc" && a.length > 3;
      var alt = a ? '<small>or the '+a[0].toLowerCase()+', '+money(aNgc ? px(a[3], a[4]) : px(a[1], a[2]))+'</small>' : '';
      rows += '<tr><td>'+sheetName(k, item.useAlias)+(other ? '<small>'+other+'</small>' : '')+'</td>'
            + (v ? '<td>'+v.set.name+' &middot; '+v.label+alt+'</td>' : '<td class="none">No hill set yet</td>')+'</tr>';
    });
  });
  if(item.custom){
    Object.keys(V).filter(function(vk){ return V[vk][0] === item.custom; }).forEach(function(vk){
      rows += '<tr><td>'+V[vk][1]+'</td><td>'+SETS[item.custom].name+'</td></tr>';
    });
  }
  (item.raw || []).forEach(function(t){
    rows += '<tr><td>'+t+'</td><td class="none">No hill set yet</td></tr>';
  });
  if(!rows) return "";
  return '<details class="how"'+(howOpen ? ' open' : '')+'><summary>Which hill goes on which map?</summary>'
       + (item.note ? '<p class="how__note">'+item.note+'</p>' : '')
       + '<div class="how__wrap"><table class="how__t"><thead><tr><th>Map</th><th>Hill set</th></tr></thead>'
       + '<tbody>'+rows+'</tbody></table></div></details>';
}

/* ---------- cart ---------- */
function refreshCart(){
  if(!ON_SHOPIFY) return;
  fetch(route("cart.js"), {headers:{"Accept":"application/json"}, credentials:"same-origin"})
    .then(function(r){ return r.json(); })
    .then(function(cart){
      inCart = {};
      (cart.items || []).forEach(function(it){ inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity; });
      /* nudge whatever the theme uses for its cart bubble and drawer */
      document.querySelectorAll("[data-cart-count],.cart-count,.cart-count-bubble span,.header__cart-count,#CartCount")
        .forEach(function(el){ el.textContent = cart.item_count; });
      ["cart:refresh","cart:updated","cart-updated","ajaxProduct:added"].forEach(function(n){
        document.dispatchEvent(new CustomEvent(n, {bubbles:true, detail:{cart:cart}}));
      });
      renderAnswer();
    })
    .catch(function(){});
}
function cartAdd(ids){
  ids.forEach(function(id){ busy[id] = "adding"; });
  renderAnswer();
  fetch(route("cart/add.js"), {
    method:"POST",
    headers:{"Content-Type":"application/json","Accept":"application/json"},
    credentials:"same-origin",
    body:JSON.stringify({items:ids.map(function(id){ return {id:Number(id), quantity:1}; })})
  })
  .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
  .then(function(res){
    if(!res.ok) throw new Error(res.body.description || res.body.message || "Could not add");
    ids.forEach(function(id){ delete busy[id]; });
    refreshCart();
  })
  .catch(function(err){
    ids.forEach(function(id){ busy[id] = "err"; });
    renderAnswer();
    setTimeout(function(){ ids.forEach(function(id){ if(busy[id] === "err") delete busy[id]; }); renderAnswer(); }, 3000);
    if(window.console) console.warn("[hill-finder]", err.message);
  });
}

/* ---------- layout helpers ---------- */
/* the theme's sticky header covers the page top; park the picker just under it */
function headerBottom(){
  var el = document.elementFromPoint(window.innerWidth / 2, 2), h = 0;
  while(el && el !== document.body){
    var p = getComputedStyle(el).position;
    if(p === "fixed" || p === "sticky"){ h = el.getBoundingClientRect().bottom; break; }
    el = el.parentElement;
  }
  return Math.max(0, h);
}
function topOffset(){ return parseFloat(hfEl.style.getPropertyValue("--hf-top")) || 96; }
function setTop(){ hfEl.style.setProperty("--hf-top", (headerBottom() + 16) + "px"); fitSticky(); }
/* the picker only sticks while it fits on screen - open sections can make it taller than the window */
function fitSticky(){
  pickEl.classList.toggle("is-sticky", !stacked.matches && pickEl.offsetHeight + topOffset() + 16 <= window.innerHeight);
}
function ansVisible(){ return ansEl.getBoundingClientRect().top < window.innerHeight - 120; }
function updateJump(){
  if(!stacked.matches || ansVisible()){ jumpEl.hidden = true; return; }
  var n = ansEl.querySelectorAll(".pcs > .pc").length;
  jumpEl.innerHTML = "See your " + (n === 1 ? "hill set" : n + " hill sets") + " &darr;";
  jumpEl.hidden = !n;
}
function scrollToEl(el){
  var y = el.getBoundingClientRect().top + window.pageYOffset - topOffset();
  try{ window.scrollTo({top:y, behavior:reduceMotion.matches ? "auto" : "smooth"}); }catch(e){ window.scrollTo(0, y); }
}

/* ---------- events ---------- */
function choose(sel){
  current = sel || current;
  expanded = {};
  markChoice();
  renderAnswer();
  updateJump();
  /* side by side: if the reader was deep in the old list, bring the new one's top back into view (only ever upwards) */
  if(!stacked.matches && ansEl.getBoundingClientRect().top < topOffset()) scrollToEl(ansEl);
}
pickEl.addEventListener("click", function(e){
  var o = e.target.closest(".opt");
  if(o) choose({kind:o.getAttribute("data-kind"), id:o.getAttribute("data-id")});
});
pickEl.addEventListener("toggle", fitSticky, true);
jumpEl.addEventListener("click", function(){ jumpEl.hidden = true; scrollToEl(ansEl); });

ansEl.addEventListener("toggle", function(e){ if(e.target.classList && e.target.classList.contains("how")) howOpen = e.target.open; }, true);
ansEl.addEventListener("click", function(e){
  if(e.target.closest("[data-change]")){ scrollToEl(pickEl); return; }
  var fin = e.target.closest("[data-color]");
  if(fin){ color = fin.getAttribute("data-color"); buildChoices(); markChoice(); renderAnswer(); return; }
  var ex = e.target.closest("[data-expand]");
  if(ex){ var sk = ex.getAttribute("data-expand"); expanded[sk] = !expanded[sk]; renderAnswer(); return; }
  var add = e.target.closest("[data-ids]");
  if(add){
    if(!ON_SHOPIFY){ var first = ansEl.querySelector(".pc__name"); if(first) window.open(first.href, "_blank", "noopener"); return; }
    cartAdd(add.getAttribute("data-ids").split(","));
    return;
  }
  /* product links always open in a new tab, even inside frames */
  var a = e.target.closest("a.pc__name, a.pc__img, a.pc__view");
  if(a && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0){
    e.preventDefault();
    window.open(a.href, "_blank", "noopener,noreferrer");
  }
});

var topQueued = false;
window.addEventListener("scroll", function(){
  if(!jumpEl.hidden && ansVisible()) jumpEl.hidden = true;
  if(topQueued) return;
  topQueued = true;
  requestAnimationFrame(function(){ topQueued = false; setTop(); });
}, {passive:true});
window.addEventListener("resize", setTop);
window.addEventListener("load", setTop);

buildChoices();
markChoice();
renderAnswer();
setTop();
refreshCart();
window.addEventListener("focus", refreshCart);
})();
